import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="mb-2">&copy; {new Date().getFullYear()} NeuralVision. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-4 mb-2">
            <Link to="/contact" className="text-white hover:text-blue-300 transition-colors">
              Contact Support
            </Link>
            <Link to="/hardware" className="text-white hover:text-blue-300 transition-colors">
              Our Hardware
            </Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-300 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-white hover:text-blue-300 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;